import { useEffect, useState } from "react";
import API from "../services/api";
import "./ProfilePage.css";

function ProfilePage() {

  const [user, setUser] = useState(null);

  // Charger l'utilisateur depuis localStorage
  useEffect(() => {

    const storedUser = JSON.parse(
      localStorage.getItem("user")
    );

    if (storedUser) {

      setUser(storedUser);

    }

  }, []);

  // Vérification du paiement Flutterwave
  useEffect(() => {

    const params =
      new URLSearchParams(
        window.location.search
      );

    const transactionId =
      params.get(
        "transaction_id"
      );

    const status =
      params.get(
        "status"
      );

    if (

      status === "successful" &&

      transactionId

    ) {

      API.get(

        `/verify-payment/${transactionId}`

      )

      .then(res => {

        console.log(
          "VIP ACTIVÉ",
          res.data
        );

        if (res.data.vip) {

          alert(
            "Votre compte VIP a été activé avec succès 🎉"
          );

        }

        // Mettre à jour localStorage
        if (res.data.user) {

          localStorage.setItem(

            "user",

            JSON.stringify(
              res.data.user
            )

          );

          setUser(
            res.data.user
          );

        }

      })

      .catch(err => {

        console.log(err);

      });

    }

  }, []);

  return (

    <div className="profile-page">

      <div className="profile-card">

        {user?.isVip && (

          <span className="vip-badge">

            👑 VIP

          </span>

        )}

        <h1>
          Mon Profil
        </h1>

        <p>

          Nom :

          {" "}

          {user?.username || "Utilisateur"}

        </p>

        <p>

          Email :

          {" "}

          {user?.email || "-"}

        </p>

        <p>

          Statut :

          {user?.isVip

            ? " 👑 VIP"

            : " Standard"}

        </p>

        {

          user?.isVip &&

          user?.vipUntil && (

            <p>

              VIP jusqu'au :

              {" "}

              {

                new Date(

                  user.vipUntil

                ).toLocaleDateString()

              }

            </p>

          )

        }

        <button

          onClick={() => {

            localStorage.removeItem("token");

            localStorage.removeItem("user");

            window.location.href =
              "/login";

          }}

        >

          Déconnexion

        </button>

        {

          user?.isAdmin && (

            <button

              onClick={() => {

                window.location.href =
                  "/admin";

              }}

            >

              Admin

            </button>

          )

        }

      </div>

    </div>

  );

}

export default ProfilePage;